import { useLocation } from 'preact-iso';

/**
 * Horizontal bar chart — good for named entities (printers, items, categories).
 * `data`: [{ label, value, href? }]. Rows with an href are clickable.
 *   <BarChart data={[{label:'Roland', value:12, href:'/printers/1'}]} accent="#34C77B" />
 */
export const BarChart = ({ data = [], accent = '#34C77B', formatValue = (v) => v, emptyLabel = 'No data in this period.' }) => {
  const { route } = useLocation();
  if (!data.length) {
    return <p class="py-6 text-center text-sm text-text-muted">{emptyLabel}</p>;
  }
  const max = Math.max(...data.map((d) => d.value), 1);

  return (
    <div class="flex flex-col gap-1.5">
      {data.map((d) => {
        const pct = (d.value / max) * 100;
        const clickable = !!d.href;
        return (
          <div
            key={d.label}
            class={`group grid grid-cols-[minmax(90px,30%)_1fr_auto] items-center gap-3 rounded-sm px-1 py-1 ${clickable ? 'cursor-pointer hover:bg-bg-base' : ''}`}
            onClick={clickable ? () => route(d.href) : undefined}
          >
            <span class="truncate text-sm text-text-secondary" title={d.label}>{d.label}</span>
            <div class="h-2.5 rounded-full bg-bg-base">
              <div class="h-full rounded-full" style={{ width: `${pct}%`, background: accent }} />
            </div>
            <span class="text-right font-mono text-xs font-medium text-text-body tabular-nums">
              {formatValue(d.value)}
            </span>
          </div>
        );
      })}
    </div>
  );
};
